import { Modal } from 'reactstrap';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 60px);
  padding: 20px;
  overflow-y: scroll;
  padding-bottom: 100px;
`;

export const Content = styled.div`
  width: 432px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #3d3d3d;

  p {
    text-align: center;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  h2 {
    font-size: 30px;
    font-weight: bold;
  }
`;

export const Card = styled.div`
  margin: 0 auto;
  height: 70vh;
  background: ${(props) => props.theme.colors.white};
  /* filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.1)); */
  border-radius: 5px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Footer = styled.div`
  position: sticky;
  flex-direction: column;
  display: flex;
  align-items: center;
  width: 100%;
  bottom: 0px;
  background: #fff;
  padding: 16px;
`;

export const ButtonsArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 16px;
`;

export const CheckboxInputStyled = styled.div`
  input[type='checkbox'] {
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: #2ec9b7;
    width: 17px;
    height: 17px;
    border: 0.15em solid #2ec9b7;
    border-radius: 0.15em;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    margin-right: 8px;
  }

  input[type='checkbox']::before {
    content: '';
    width: 0.65em;
    height: 0.65em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em #2ec9b7;
    transform-origin: bottom left;

    clip-path: ${(props) =>
    props.allChecksChecked
      ? 'inset(50% 20% 44% 10%);'
      : 'polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%)'};
  }

  input[type='checkbox']:checked::before {
    transform: scale(1);
    background-color: #2ec9b7;
  }

  .form-control + .form-control {
    margin-top: 1em;
  }

  input[type='checkbox']:disabled {
    color: #3c3c3c;
    cursor: not-allowed;
  }
`;

export const InputStyled = styled.input`
  width: 65px;
  height: 38px;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  text-align: center;
  margin-right: 8px;
`;

export const ScreenOne = styled.div`
  width: 100%;
  display: ${(props) => (props.active === 1 ? 'block' : 'none')};
  height: 80vh;
  max-height: 80vh;
  padding: 16px;
  padding-bottom: 120px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ScreenTwo = styled.div`
  width: 100%;
  display: ${(props) => (props.active === 2 ? 'block' : 'none')};
  height: 80vh;
  max-height: 80vh;
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  padding-bottom: 120px;
`;

export const ScreenThree = styled.div`
  width: 100%;
  display: ${(props) => (props.active === 3 ? 'block' : 'none')};
  height: 80vh;
  max-height: 80vh;
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 120px;
`;

export const ScreenTitle = styled.p`
  color: #222;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const ModalStyled = styled(Modal)`
  .modal-content {
    width: 800px;
    max-height: 80vh;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    left: -120px;
  }

  .modal-header {
    padding: 16px;
    padding-bottom: 0px;
  }

  .modal-body {
    padding: 16px;
    flex: 1;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  min-width: 400px;
  align-items: center;
  margin-top: 10px;
  border-spacing: 0 20px;

  th,
  td {
    padding: 10px;
  }

  thead {
    border-bottom: none;
    text-align: left;
    background: #efefef;
    color: #6c6c6c;

    tr,
    th {
      border-color: #fff;
      border-style: solid;
      border-width: 4px;
      border-left: none;
    }

    /* tr {
      th:last-child {
        text-align: right;
      }
    } */
  }
  tbody {
    td {
      border-bottom: 1px solid #dee2e6;
    }
    /* td:last-child {
      text-align: right;
    } */

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const InputLine = styled.div`
  display: flex;

  gap: 16px;
  align-items: center;

  label {
    align-items: flex-start;
  }
`;

export const KdsInfoArea = styled.div`
  margin-top: 16px;
`;

export const ViewArea = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  align-self: stretch;
  border-radius: 12px;
  background: #f6f6f6;
  margin-top: 24px;
`;

export const ViewAreaTitle = styled.div`
  color: #6c6c6c;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-self: stretch;
`;

export const ViewAreaSubtitle = styled.div`
  color: #6c6c6c;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-self: stretch;
`;

export const View = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  background: #f6f6f6;
  border-radius: 12px;
  border: 1px solid #c6c6c6;

  p {
    color: #545454;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const KitchenItem = styled.div`
  display: flex;
  width: 89px;
  height: 89px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #2ec9b7;
  border-radius: 12px;

  p {
    color: #fff;
    word-wrap: break-word;
  }
`;

export const KdsItems = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  flex-wrap: wrap;
`;

export const StepsContainer = styled.div`
  padding-bottom: 40px;
`;

export const StepItem = styled.div`
  margin-top: 16px;
`;

export const StepTitle = styled.p`
  color: #545454;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
`;
